import { AppUtils } from '../../utils/index';

import { BaseApiModel } from './BaseApiModel';


/**
 * APIL Url: ADAC.Internet.Types.AdacResultMessage
 * 
 * Endpoints: /api/Adress, /api/Adress/update, /api/Adress/delete, /api/Altersstufen, /api/Autokredit, /api/BankOperation/check, /api/BankOperation/convert, /api/BankOperation/sepamandat, /api/consentmanagement/lesen, /api/consentmanagement/status, /api/consentmanagement/speichern, /api/consentmanagement/speicherncss, /api/consentmanagement/zustimmenapplikation, /api/documents/checkconvertible, /api/v2/versicherungen/fahrrad/berechnen, /api/v2/versicherungen/fahrrad/anlage, /api/v2/versicherungen/fahrrad/v2/schaden, /api/v2/versicherungen/fahrrad/angebot, /api/v2/versicherungen/fahrrad/angebotlesen, /api/fahrzeugdaten/marken, /api/fahrzeugdaten/baureihen, /api/fahrzeugdaten/modelle, /api/fahrzeugdaten/suche, /api/fahrzeugdaten/detail/{id}, /api/fahrzeugdaten/detail/{id}/simple, /api/fahrzeugkey/marken, /api/fahrzeugkey/baureihen, /api/fahrzeugkey/baureihegenerationen, /api/fahrzeugkey/modellvarianten, /api/fahrzeugkey/fahrzeuge, /api/fahrzeugkey/modelle, /api/fahrzeugkey/tetschluesselaufloesen, /api/fahrzeugkey/token, /api/fahrzeugkey, /api/FreundschaftsWerbung/LeseWerbedepot, /api/FreundschaftsWerbung/DigitalerGutscheinBytes, /api/FreundschaftsWerbung/Empfehlungslink, /api/FreundschaftsWerbung/Empfehlungsdaten, /api/friendlycaptcha/validate, /api/Garage/{id}, /api/Garage/SpeicherFahrzeugscheinBild, /api/haustier/berechnen, /api/haustier/anlage, /api/haustier/angebot, /api/haustier/angebotlesen, /api/Identity, /api/Identity/IstReinerOnlineKunde, /api/Identity/IdentUnverified, /api/Identity/MfaStatus, /api/Identity/ResetMfa, /api/Identity/retrieveregisterjwt, /api/Kommunikation, /api/v2/kuendigung/kuendigerstatus, /api/v2/kuendigung/pruefebenutzer, /api/v2/kuendigung/kuendigemitgliedschaft, /api/v2/kuendigung/bestaetigung/ids, /api/maengelforum/marken, /api/maengelforum/modelle, /api/maengelforum/baureihegenerationen, /api/maengelforum/motorarten, /api/maengelforum/baugruppen, /api/maengelforum/bauteile, /api/maengelforum/baujahre, /api/maengelforum/maengelliste, /api/maengelforum/maengellistebykfzid, /api/maengelforum/maengellistebybaureihegenerationid, /api/maengelforum/maengelmeldung, /api/maengelforum/meldungmotorarten, /api/maengelforum/meldungjahre, /api/maengelforum/meldungbaujahre, /api/maengelforum/meldungmarken, /api/maengelforum/meldungbaureihen, /api/maengelforum/meldungbaureihegenerationen, /api/maengelforum/meldungmodellvarianten, /api/maengelforum/meldungfahrzeuge, /api/MatchCandidate/matchdata, /api/MatchCandidate/token, /api/MatchCandidate, /api/MeineDaten/Update, /api/MeineDaten/familienverbund, /api/MeineDaten/vesvertraege, /api/MeineDaten/hatAks, /api/MeineDaten/vesvertragsdetail, /api/MeineDaten/vesorderdoc, /api/MeineDaten/vescancel, /api/MeineDaten/vesfinanzamtbescheinigung, /api/MeineDaten/ersatzversand, /api/MeineDaten/prenotification, /api/MeineDaten/lesegeldeinzug, /api/MeineDaten/listemglrechnungen, /api/MeineDaten/listevesrechnungen, /api/MeineDaten/lesemglrechnung/{id}, /api/MeineDaten/lesevesrechnung/{id}, /api/meinpostfach/leseDokument, /api/MglTarif, /api/MglTarif/tarifliste, /api/MglTarif/tarifempfehlung, /api/MglTarif/checkgeburtsdatum, /api/MglTarif/checkmglanlagebeginn, /api/mitgliedschaft, /api/mitgliedschaft/younggeneration, /api/mitgliedschaft/check24, /api/mitgliedschaft/check24ev, /api/mitgliedschaft/erweitern, /api/mitgliedschaft/finanzdienste/kreditkarte, /api/mitgliedschaft/finanzdienste/modulkreditkarte, /api/mitgliedschaft/finanzdienste/autokredit, /api/mitgliedschaft/versicherungen/auto, /api/mitgliedschaft/mglcheck, /api/mitgliedschaft/mglcheck/withves, /api/mitgliedschaft/checkmglwbs, /api/mitgliedschaft/profiwerber/agw, /api/mitgliedschaft/profiwerber/mew, /api/mitgliedschaft/profiwerber/sww, /api/mitgliedschaft/erweitern/profiwerber/agw, /api/mitgliedschaft/erweitern/profiwerber/mew, /api/mitgliedschaft/erweitern/profiwerber/sww, /api/mitgliedschaft/gewinnspielpruefen, /api/mitgliedschaft/gewinnspielspeichern, /api/MitgliedschaftGutschein/nextcode, /api/MitgliedschaftGutschein/token, /api/MitgliedschaftGutschein, /api/v2/mitgliedschaft/token, /api/v2/mitgliedschaft, /api/modulkreditkarte/istberechtigt, /api/modulkreditkarte/aktion, /api/modulkreditkarte/lesekreditkarten, /api/modulkreditkarte/lesekreditkartencss, /api/modulkreditkarte/encrypt, /api/modulkreditkarte/jwetokenrequest, /api/v2/newsletter/create, /api/v2/newsletter/update, /api/v2/newsletter/get, /api/notfall/daten/hasany, /api/notfall/daten/delete, /api/notfall/pass/delete, /api/notfall/pass/update, /api/notification/channels/{channelId}/messages/latest, /api/notification/channels/{channelId}/messages/{messageId}, /api/notification/channels/{channelId}/messages, /api/notification/token, /api/notification, /api/Pannenhilfe/meldung, /api/Pannenhilfe/geocheck, /api/Pannenhilfe/storno, /api/Pannenhilfe/gelberengelgeo, /api/Pannenhilfe/systemstatus, /api/Pannenhilfe/systemstatuseta, /api/Pannenhilfe/systemstatussms, /api/Pannenhilfe/notizerstellen, /api/Pannenhilfe/token, /api/Pannenhilfe, /api/Pay/encryption, /api/pdfstorage/rcmglversammlung, /api/pdfstorage/schadenmeldung, /api/pdfstorage/startersetpdf, /api/pdfstorage/sepamandat, /api/profiwerber/agw, /api/profiwerber/mew, /api/profiwerber/sww, /api/ps/berechnen, /api/ps/anlage, /api/rrv/berechnen, /api/rrv/anlage, /api/rrv/anlageextern, /api/rrv/angebot, /api/schadenmeldungen/schutzbrief, /api/schadenmeldungen/aks, /api/schadenmeldungen/rrv, /api/schadenmeldungen/zwischenspeichernschutzbrief, /api/schadenmeldungen/schadenlesen, /api/schadenmeldungen/gespeicherteschaedenliste, /api/schadenmeldungen/gemeldeteschaedenliste, /api/schadenmeldungen/dokumentnachreichen, /api/schadenmeldungen/zwischenspeicherloeschen, /api/schadenmeldungen/schadenkosten, /api/schadenmeldungen/schadenzusammenfassung, /api/schadenmeldungen/insis/suche, /api/schadenmeldungen/insis/dokumentnachreichen, /api/schadenmeldungen/insis/rrv, /api/touristik/tourset, /api/touristik/toursetaktualisieren, /api/touristik/toursetstornieren, /api/touristik/toursetslesen, /api/touristik/toursetlesen, /api/us/berechnen, /api/us/anlage, /api/us/angebot, /api/versicherungen/aksbep/berechnen, /api/versicherungen/aksbep/anlage, /api/versicherungen/aks/anlageextern, /api/versicherungen/aks/anlageexternloyjoy, /api/versicherungen/akslangzeit/berechnen, /api/versicherungen/akslangzeit/anlage, /api/versicherungen/incoming/berechnen, /api/versicherungen/incoming/anlage, /api/versicherungen/brs/berechnen, /api/versicherungen/brs/anlage, /api/versicherungen/rechtschutz/pruefezugang, /api/versicherungen/rechtschutz/generierechattoken, /api/versicherungen/rechtschutz/generiereluztoken, /api/versicherungen/rechtschutz/generiereonlineberatungToken, /api/versicherungen/rechtschutz/generierevertragschecktoken, /api/versicherungen/rechtschutz/generiereonlinedienstleistungstoken, /api/versicherungen/phv/berechnen, /api/versicherungen/phv/anlage, /api/versicherungen/us/berechnen, /api/versicherungen/us/pruefen, /api/versicherungen/us/anlage, /api/versicherungen/ps/berechnen, /api/versicherungen/ps/anlage, /api/versicherungen/brs/angebot, /api/versicherungen/us/angebot, /api/versicherungen/aks/angebot, /api/versicherungen/akslangzeit/angebot, /api/versicherungen/brs/leseangebot, /api/versicherungen/us/leseangebot, /api/versicherungen/aks/leseangebot, /api/versicherungen/akslangzeit/leseangebot, /api/versicherungen/leseangebotliste, /api/versicherungen/all/optinspeichern, /api/versicherungen/auto, /api/versicherungen/autopartnerextern, /api/versicherungen/moped, /api/versicherungen/autovorbelegbar, /api/versicherungen/auto/tippgeber/init, /api/versicherungen/auto/tippgeber/finish, /api/v2/versicherungen/rrv/berechnen, /api/v2/versicherungen/rrv/anlage, /api/v2/versicherungen/rrv/anlageextern, /api/v2/versicherungen/rrv/angebot, /api/v2/versicherungen/rrv/leseangebot, /api/WalletProxy/mglpassjson, /api/WalletProxy/mglpassqrcode, /api/WalletProxy/mglpassurl, /api/WalletProxy/pannenpassqrcode, /api/WalletProxy/pannenpassurl, /api/Zahlungsweisen/payone, /api/zuhause/hausrat/berechnen, /api/zuhause/hausrat/anlage, /api/zuhause/hausrat/druckstueck, /api/zuhause/hausrat/angebot, /api/zuhause/hausrat/angebotlesen, /api/zuhause/schutzbrief/berechnen, /api/zuhause/schutzbrief/anlage, /api/zuhause/schutzbrief/druckstueck, /api/zuhause/schutzbrief/angebot, /api/zuhause/schutzbrief/angebotlesen
 */
export class AdacResultMessageApi extends BaseApiModel {
	constructor(initialProperties?: Partial<AdacResultMessageApi>) {
		super();
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	protected id: number;
	/**
	 * Description: 
	 * APIL Type: int32
	 */
	get Id(): number {
		return this.id;
	}

	/**
	 * Description: 
	 * APIL Type: int32
	 */
	set Id(value: number) {
		this.id = value;
	}

	protected source: string;
	/**
	 * Description: 
	 * APIL Type: string
	 */
	get Source(): string {
		return this.source;
	}

	/**
	 * Description: 
	 * APIL Type: string
	 */
	set Source(value: string) {
		this.source = value;
	}

	protected message: string;
	/**
	 * Description: 
	 * APIL Type: string
	 */
	get Message(): string {
		return this.message;
	}

	/**
	 * Description: 
	 * APIL Type: string
	 */
	set Message(value: string) {
		this.message = value;
	}

	protected stop: boolean;
	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	get Stop(): boolean {
		return this.stop;
	}

	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	set Stop(value: boolean) {
		this.stop = value;
	}

	protected cancelledOnValidation: boolean;
	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	get CancelledOnValidation(): boolean {
		return this.cancelledOnValidation;
	}

	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	set CancelledOnValidation(value: boolean) {
		this.cancelledOnValidation = value;
	}

	protected group: boolean;
	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	get Group(): boolean {
		return this.group;
	}

	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	set Group(value: boolean) {
		this.group = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): AdacResultMessageApi {
		return AppUtils.Helper.createFromMap(dataObject, AdacResultMessageApi, (key, value) => {
			switch (key.toLowerCase()) {

				default:
					return value;
			}
		});
	}

	public toRequestObject(): { [key: string]: any } {
		const result: { [key: string]: any } = {};
		result.Id = this.id;
		result.Source = this.source;
		result.Message = this.message;
		result.Stop = this.stop;
		result.CancelledOnValidation = this.cancelledOnValidation;
		result.Group = this.group;
		return result;
	}

	public toJsonString(): string {
		return JSON.stringify(this.toRequestObject());
	}
}